export const cookieBar = (
    state = {
        cookiebarVisible: false,
        showButton: false,
        settingsVisible: false,
        functional: false,
        analytics: false,
        marketing: false,
        personalization: false
    }) => { return state; };